import { year2017 } from "./2017";
import { year2018 } from "./2018";
import { year2019 } from "./2019";
import { year2020 } from "./2020";
import { year2021 } from "./2021";
import { year2022 } from "./2022";
import { year2023 } from "./2023";
import { year2024 } from "./2024";
import { year2025 } from "./2025";
import { year2026 } from "./2026";

export const learning = [
  ...year2026,
  ...year2025,
  ...year2024,
  ...year2023,
  ...year2022,
  ...year2021,
  ...year2020,
  ...year2019,
  ...year2018,
  ...year2017,
];
